import { render } from "./MapeoErpForm.vue?vue&type=template&id=bec42c7c&scoped=true"
import script from "./MapeoErpForm.vue?vue&type=script&lang=js"
export * from "./MapeoErpForm.vue?vue&type=script&lang=js"

import "./MapeoErpForm.vue?vue&type=style&index=0&id=bec42c7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bec42c7c"]])

export default __exports__